import ListOrder from "./order/list-order";
import CreateOrder from "./order/create-order";
// import ApproveOrder from "./order/approve-order";
// import ListOrderPiking from "./order/list-order-piking";
// import { PikingAssignment } from "./order/piking-assignment";
// import { PikingOverride } from "./order/piking-override";
// import ItemsMarshal from "./order/items-marshal"
const WmsOutwardRoutes = [
    {
        path: '/outward/order/list',
        element: <ListOrder />
    }
    ,
    {
        path: '/outward/Order/create',
        element: <CreateOrder />
    },
    // {
    //     path: '/outward/Order/approve',
    //     element: <ApproveOrder />
    // },
    // {
    //     path: '/outward/Picking/list',
    //     element: <ListOrderPiking />
    // }

];
export default WmsOutwardRoutes;